var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('warningdlg',_vm._l((_vm.$store.state.warning.button),function(item,index){return _c('el-button',{key:index,attrs:{"id":true?item.name:''},on:{"click":item.callBack}},[_vm._v(_vm._s(item.name))])}),1),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('promotionListDlg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }